<template>
  <section>
    <!-- 创建反馈 -->
    <pb-drawer :visible.sync="sendOpen" :wrapper-closable="false" size="480px">
      <template #title>
        <div>
          <span>{{ $t('Gattaran_Feedback__LtzD' /** 问题反馈 */) }}</span>
          <i class="pb-icon-question" @click="toInstruction"> How to use Feedback</i>
        </div>
      </template>
      <div class="feedback-wrap">
        <FormProvider :form="form">
          <SchemaField
            :schema="schema"
            :scope="{
              useAsyncDataSource,
              doGetModule,
              doGetArea,
            }"
          />
        </FormProvider>
      </div>
      <FormProvider :form="form">
        <FormButtonGroup class="feedback-footer">
          <Reset class="feedback-footer-reset">{{
            $t('Gattaran_MSGCenter__rffG' /** 重置 */)
          }}</Reset>
          <div class="feedback-button">
            <pb-button type="button" class="feedback-butto-cancel" @click="doClose">{{
              $t('Gattaran_Feedback__dGOG' /** 取消 */)
            }}</pb-button>
            <Submit class="feedback-butto-submit" :on-submit="doSubmit">{{
              $t('Gattaran_Feedback__HTsy' /** 提交 */)
            }}</Submit>
          </div>
        </FormButtonGroup>
      </FormProvider>
    </pb-drawer>
    <!-- 发送成功 -->
    <SendSuccess ref="card-success" :ticket-link="ticketLink" />
  </section>
</template>

<script>
import { createForm } from '@formily/core'
import { createSchemaField, FormProvider } from '@formily/vue'
import {
  Form,
  FormItem,
  FormLayout,
  FormGrid,
  Input,
  Select,
  Checkbox,
  Radio,
  DatePicker,
  TimePicker,
  Cascader,
  Upload,
  FormButtonGroup,
  Reset,
  Submit,
  ArrayItems,
} from '@didi-pebble/formily-pebble'
import { action } from '@formily/reactive'
import { createSendFormSchema } from '../config'
import { API } from '../services'
import SendSuccess from '../components/send-success.vue'
import { filterCurModule } from '../utils/index'

const form = createForm({
  effects() {},
})

const fields = createSchemaField({
  components: {
    Form,
    Input,
    Select,
    Checkbox,
    Radio,
    DatePicker,
    TimePicker,
    FormLayout,
    FormGrid,
    FormItem,
    Cascader,
    Upload,
    FormButtonGroup,
    ArrayItems,
  },
})

const useAsyncDataSource = service => field => {
  service(field).then(
    action.bound(data => {
      field.dataSource = data
    }),
  )
}

export default {
  components: { FormProvider, FormButtonGroup, Reset, Submit, ...fields, SendSuccess },
  data() {
    // 基础设置Schema
    const schema = createSendFormSchema(this)
    return {
      form,
      schema,
      sendOpen: false,
      loading: false,
      ticketLink: '',
    }
  },
  watch: {
    sendOpen: {
      async handler(isOpen) {
        if (isOpen) {
          await API()
            .getProductModule()
            .then(res => (this.modules = res))
          this.form.setValues({
            // 自动匹配问题所属功能模块
            module: filterCurModule(this.modules),
            // 自动匹配问题当前url
            link: window.location.href,
          })
        }
      },
    },
  },
  methods: {
    useAsyncDataSource,
    // 所属模块
    async doGetModule() {
      return this.modules
    },
    // 区域筛选
    async doGetArea() {
      await API()
        .getAuthCountry()
        .then(res => {
          this.country = res.map(e => {
            return {
              label: e.label,
              value: e.value,
            }
          })
        })
      return this.country
    },
    // 跳往链接说明
    toInstruction() {
      window.open('https://cooper.didichuxing.com/docs/document/2199740546553')
    },
    doClose() {
      this.sendOpen = false
    },
    doSubmit() {
      if (this.loading === true) {
        return this.$t('FoodB_202502_iDjM_HZOr') // 请勿重复提交
      }
      const { picture, attachment, module, area, link } = this.form.values
      // 网址必须以http://或者https://开头
      const reg = /^(http|https):\/\/([\w.]+\/?)\S*/
      if (!reg.test(link)) {
        this.$message({
          message: this.$t('Gattaran_Feedback__ktgU' /** 这不是一个合格的页面链接 */),
          type: 'error',
        })
        return
      }
      this.picture = Array.isArray(picture) ? picture.map(e => e.response.data) : []
      this.attachment = Array.isArray(attachment) ? attachment.map(e => e.response.data) : []
      // 由于问题发生选中后会展示完整路径，而用户真实选择的区域只是路径最后一项
      // this.area = []
      // area.forEach(e => {
      //   return this.area.push(...e.slice(-1))
      // })
      delete this.form.values.picture
      this.loading = true
      API()
        .createFeedback({
          ...this.form.values,
          module: module.toString(),
          area: JSON.stringify(area),
          pic: JSON.stringify(this.picture),
          attachment: JSON.stringify(this.attachment),
        })
        .then(res => {
          this.sendOpen = false
          this.form.reset()
          this.ticketLink = res?.link || 'http://ticket.intra.didiglobal.com'
          this.$refs['card-success'].isShow = true
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.feedback-wrap {
  padding: 24px;
  margin-bottom: 81px;
}

.feedback-footer {
  width: 480px;
  height: 64px;
  position: fixed;
  bottom: 0;
  background: #ffffff;
  border-top: 1px solid #e9eaee;
  z-index: 999;
}

.feedback-button {
  position: absolute;
  right: 20px;
  bottom: 16px;
  display: flex;
  flex-direction: row;
}

.feedback-footer-reset {
  height: 32px;
  position: absolute;
  bottom: 16px;
  left: 16px;
  padding: 5px 16px;
  background: rgba(255, 255, 255, 0);
  border: none;
  font-size: 14px;
  color: #f76a31;
  line-height: 22px;
  font-weight: normal;
}

.feedback-button-cancel {
  padding: 5px 16px;
}

.feedback-button-submit {
  padding: 5px 16px;
}

.pb-icon-question {
  margin-left: 16px;
  cursor: pointer;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #8d9099;
  line-height: 22px;
  font-weight: 400;
}

.pb-icon-question:hover {
  color: #f76a31;
}

:deep(.pb-drawer__header) {
  height: 56px;
  margin-bottom: 0;
  border-bottom: 1px solid #e9eaee;
  box-sizing: border-box;
  padding: 16px 12px 16px 16px;
  font-family: DiDiSans-Pro-Medium;
  font-size: 16px;
  color: #282b33;
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 500;
}

:deep(.pb-drawer__close-btn) {
  font-size: 16px;
  margin-right: -6px;
}
:deep(.pb-drawer__body) {
  padding: 0;
}
</style>
